import { IAdminProgramCodeRiskLevel } from '@interfaces/adminProgramCodes';
import { IRiskLevelDescription } from '@interfaces/lookups';

export const updateRiskLevels = (
  value: IAdminProgramCodeRiskLevel[],
  riskLevelId: number,
  riskLevelDescriptionId: number,
  descriptions: IRiskLevelDescription[],
): IAdminProgramCodeRiskLevel[] => {
  const riskLevelDescription = descriptions.find(item => item.id === riskLevelDescriptionId)?.name;
  if (!riskLevelDescription) return value;

  const currentRiskLevel = value.find(item => item.riskLevelId === riskLevelId);
  const newRiskLevel = {
    riskLevelId,
    riskLevelDescriptionId,
    riskLevelDescription,
  };

  return currentRiskLevel
    ? value.map(item => (item.riskLevelId === riskLevelId ? newRiskLevel : item))
    : [...value, newRiskLevel];
};
